import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';

const menuPortalStyles = {
  menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 'var(--z-popover)' }),
};

const WeatherMapSelect = ({
  options = [],
  selectedValue,
  onChange,
  label,
  ariaLabel,
  placeholder,
  noOptionsMessage,
  wrapperClassName,
  isDisabled = false,
}) => (
  <BaseSelect
    wrapperClassName={wrapperClassName}
    label={label}
    isSearchable
    styles={menuPortalStyles}
    selectProps={{
      'aria-label': ariaLabel,
      options,
      value: findSelectOption(options, selectedValue),
      onChange: (option) => onChange?.(option?.value ?? null),
      placeholder,
      noOptionsMessage: () => noOptionsMessage,
      isDisabled,
      menuPosition: 'fixed',
      menuPortalTarget: typeof document === 'undefined' ? undefined : document.body,
    }}
  />
);

export default WeatherMapSelect;
